import React, {useState} from 'react';
import MyColorPicker from '../../colorPicker';
import { MODALS } from '../../../../config/images';
const ModalColorPicker = ({ showModalColorPicker, closeModalColorPicker, setSelectedColor }) => {
  const [color, setColor] = useState('#008000');

  const handleAccept = () => {
    setSelectedColor(color);
    closeModalColorPicker(); 
  };

  if (!showModalColorPicker) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="w-[80%] sm:w-[50%] lg:w-[30%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModalColorPicker}
            className="rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-3 pb-4 sm:px-8'>
            <p className="text-lg text-blue font-itcdemi">Escoger color</p>
            <MyColorPicker color={color} setColor={setColor}/>
            <button
                onClick={handleAccept}
                className='text-sm underline text-blue font-itcbook '>
                Aceptar
            </button>
        </div>
          
        </div>
      </div>
  );
};
export default ModalColorPicker;
